import { render, staticRenderFns } from "./ListAntecedents.vue?vue&type=template&id=01fd3140&"
import script from "./ListAntecedents.vue?vue&type=script&lang=js&"
export * from "./ListAntecedents.vue?vue&type=script&lang=js&"
import style0 from "./ListAntecedents.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports